// PR 58 / 59 FIXES · agent A — screen texts, EN + AR. Merged into lib/i18n.js translations (big-file rule: new strings in their
// own file).
//   F3  Sampling: the confidence level starts empty and must be chosen (Stage 1 · A-23; the backend refusal is
//       SAMPLE_CONFIDENCE_REQUIRED).
export const I18N_FX_A = {
  en: {
    fxA: {
      sampling: {
        confidencePlaceholder: "Choose",
        confidenceRequired: "Choose the confidence level for this sample (25% to 100%). There is no default level.",
      },
    },
  },
  ar: {
    fxA: {
      sampling: {
        confidencePlaceholder: "اختر",
        confidenceRequired: "اختر مستوى الثقة لهذه العينة (من 25% إلى 100%). لا يوجد مستوى افتراضي.",
      },
    },
  },
};

export default I18N_FX_A;
